export const isLoadingSettings = (state) => state.settings?.loading;

export const selectSettings = (state) => state.settings?.byModule;
